//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const attr = function(attributes, key) {
    if (!attributes) {
      return null;
    }

    return attributes[key] ? attributes[key].nodeValue : null;
  };

  const generateColumnDefinitions = function(columns) {
    return _(columns).map((column) => {
      const attributes = column.attributes;

      return {
        name: attr(attributes, 'name'),
        key: attr(attributes, 'key'),
        sortKey: attr(attributes, 'sortKey') || attr(attributes, 'key'),
        klass: attr(attributes, 'class'),
        headerKlass: attr(attributes, 'header-class'),
        headerTitle: attr(attributes, 'header-title'),
        sortable: attr(attributes, 'sortable') === 'true',
        format: attr(attributes, 'format'),
        multiColHeader: attr(attributes, 'datatable-multi-col-header') === 'true',
        attrs: attributes,
        grouped: attr(attributes, 'grouped') === 'true',
        ngIf: attr(attributes, 'ng-if'),
      };
    });
  };

  const generateUpperHeaderDefinitions = function(headers) {
    return _(headers).map((header) => {
      const attributes = header.attributes;

      return {
        innerHTML: header.innerHTML,
        colspan: attr(attributes, 'colspan'),
        rowspan: attr(attributes, 'rowspan'),
        scope: attr(attributes, 'scope'),
        klass: attr(attributes, 'class'),
        id: attr(attributes, 'id'),
      };
    });
  };

  const applyAttributes = function(elem, attributes) {
    let i = 0;
    let key;

    for (; i < attributes.length; i++) {
      key = attributes[i].name;
      if (attributes.hasOwnProperty(key)) {
        switch (key) {
          case 'name':
          case 'key':
          case 'sortKey':
          case 'class':
          case 'header-class':
          case 'sortable':
          case 'format':
          case 'datatable-multi-col-header':
            break; // break from switch, do nothing
          default: {
            elem.attr(key, attr(attributes, key));
            break;
          }
        }
      }
    }
  };

  angular.module('curalate').directive('datatableTable', () => ({
    restrict: 'E',
    scope: {},
    require: '^datatable',
    compile(element) {
      const tableWrapper = angular.element('<div />').addClass('angular-datatable datatables-next no-padding col-xs-12');
      const table = angular.element('<table />').addClass('table');
      const columns = element.find('datatable-table-column');
      const columnObjects = generateColumnDefinitions(columns);
      const thead = angular.element('<thead/>');

      const headerColumns = _(columnObjects)
                    .map((definition) => {
                      let multiColHeader;
                      let sortStr;
                      let sortKeys;
                      const th = angular.element('<th />').addClass('header');

                      if (definition.name && !definition.multiColHeader) {
                        th.text(definition.name);
                      }

                      if (definition.headerKlass) {
                        th.addClass(definition.headerKlass);
                      }

                      if (definition.headerTitle) {
                        th.attr('title', definition.headerTitle);
                      }

                      if (definition.ngIf) {
                        th.attr('ng-if', definition.ngIf);
                      }

                      if (definition.sortable && definition.sortKey) {
                        th.addClass('sortable');

                        if (definition.multiColHeader) {
                          sortKeys = JSON.parse(definition.sortKey);
                          th.attr('ng-click', `model.sort("${sortKeys}")`);
                          sortStr = `(model.sorting.currentSortKey == "${sortKeys.join('" || model.sorting.currentSortKey == "')}")`;
                          th.attr('ng-class',
                                        `{ "sort-asc": ${sortStr} && model.sorting.direction === "asc", ` +
                                          `"sort-desc": ${sortStr} && model.sorting.direction === "desc" }`,
                                );

                          multiColHeader = angular.element('<datatable-multi-column-header />');
                          multiColHeader.attr('sort-key', definition.sortKey);
                          multiColHeader.attr('name', definition.name);
                          th.append(multiColHeader);
                        } else {
                          th.attr('ng-click', `model.sort("${definition.sortKey}")`);

                          th.attr('ng-class',
                                        `{ "sort-asc": model.sorting.currentSortKey == "${definition.sortKey}" && model.sorting.direction === "asc", ` +
                                          `"sort-desc": model.sorting.currentSortKey == "${definition.sortKey}" && model.sorting.direction === "desc" }`,
                                );
                        }
                      }

                      return th;
                    });
      const headerRow = angular.element('<tr />');
      _(headerColumns).each((r) => { headerRow.append(r); });

      const headerUpperRow = angular.element('<tr />');
      const upperHeader = element.find('datatable-table-upper-header');

      if (upperHeader[0]) {
        headerUpperRow.attr('ng-if', attr(upperHeader[0].attributes, 'ng-if'));

        const upperHeaderHeaders = element.find('datatable-table-upper-header datatable-table-header');
        const headerObjects = generateUpperHeaderDefinitions(upperHeaderHeaders);
        const upperHeaders = _(headerObjects).map((h) => {
          const th = angular.element('<th />');
          th.attr('rowspan', h.rowspan);
          th.attr('colspan', h.colspan);
          th.attr('scope', 'colgroup');
          th.attr('id', h.id);
          th.addClass(h.klass);
          th.text(h.innerHTML);
          return th;
        });

        _(upperHeaders).each(h => headerUpperRow.append(h));
      }

            // Map columns to single row definition
      const row = _.chain(columns)
                    .map((col, idx) => {
                      const td = angular.element('<td />');

                      if (columnObjects[idx].key && columnObjects[idx].format === 'number') {
                        td.html(`{{ context.${columnObjects[idx].key} | readableNumber }}`);
                      } else if (columnObjects[idx].key && columnObjects[idx].format === 'optionalNumber') {
                        td.html(`{{ context.${columnObjects[idx].key} | optionalReadableNumber }}`);
                      } else if (columnObjects[idx].key && columnObjects[idx].format === 'percentage') {
                        td.html(`{{ context.${columnObjects[idx].key} | readablePercent: true }}`);
                      } else if (columnObjects[idx].key && columnObjects[idx].format === 'optionalPercentage') {
                        td.html(`{{ context.${columnObjects[idx].key} | optionalReadablePercent: true }}`);
                      } else if (columnObjects[idx].key && columnObjects[idx].format === 'price') {
                        td.html(`{{ context.${columnObjects[idx].key} | readablePrice }}`);
                      } else if (columnObjects[idx].key) {
                        td.html(`{{ context.${columnObjects[idx].key} }}`);
                      } else {
                        td.html(col.innerHTML);
                      }

                      if (columnObjects[idx].klass) {
                        td.addClass(columnObjects[idx].klass);
                      }

                      applyAttributes(td, columnObjects[idx].attrs);
                      return td;
                    });

      const tbody = angular.element('<tbody />');
      const rows = angular.element('<tr />').attr('ng-repeat', 'context in model.items');
      _(row).each((r) => { rows.append(r); });

      thead.append(headerUpperRow);
      thead.append(headerRow);
      tbody.append(rows);
      table.append(thead);
      table.append(tbody);
      tableWrapper.append(table);
      columns.remove();

      return {
        pre: null,
        post(scope, elem, attrs, datatable) {
          datatable.registerView('table', tableWrapper);
        },
      };
    },
  }));
})();
